import React, { useState, useEffect } from 'react';
import { useForm } from 'react-final-form';
import { Editor } from '@tinymce/tinymce-react';

export const ContactInfo = ({ formData, ...rest }) => {
    const form = useForm();
    const [editorValue, setEditorValue] = useState(formData.projectContactInformation);

    useEffect(() => {
        setEditorValue(formData.projectContactInformation);
    }, [formData.projectContactInformation]);

    const handleEditorChange = (content) => {
        setEditorValue(content);
        form.change('projectContactInformation', content);
    };

    return (
        <div>
            <h6>Contact Information</h6>
            <Editor
              apiKey="gsr9de585py37ujyollv3160go05b3xmbqo7r54eq3l4iise"
               value={editorValue}
                 
               init={{
                plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage advtemplate ai mentions tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss markdown',
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                tinycomments_mode: 'embedded',
                tinycomments_author: 'Author name',
                mergetags_list: [
                  { value: 'First.Name', title: 'First Name' },
                  { value: 'Email', title: 'Email' },
                ],
                ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
              }}
                onEditorChange={handleEditorChange}
            />
        </div>
    );
};
